// extracted by mini-css-extract-plugin
module.exports = {"DetailPartsChapter":"Chapter_DetailPartsChapter__q3Wv_","DetailPartsChapterMedia":"Chapter_DetailPartsChapterMedia__VuPdY"};